<h4>Willkommen bei Darwins Reisen!</h4>

<mat-card>
  <mat-card-header>
    <mat-card-title>Wintersport Reisen</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Seit über 25 Jahren sind wir für unsere Kunden in Sachen Boardsports unterwegs und seit über 20 Jahren bieten wir
    das dazugehörige Reiseprogramm das sich im Laufe der Jahre stets verbessert hat bis es zu dem einzigartigen
    Reiseerlebnis wurde das es jetzt ist.
    Das Programm bietet Tages- Wochenend- und Mehrtagesreisen mit dem Schwerpunkt Boardsport aber auch Snowkiter und
    Tourengeher kommen nicht zu kurz.
  </mat-card-content>
  <mat-card-actions>
    <button mat-button color="primary" routerLink="/wintersportreisen">zu den Wintersport Reisen</button>
    <button mat-button color="primary" routerLink="/buchung" *ngIf="service.env.buchungEnabled">jetzt buchen</button>
  </mat-card-actions>
</mat-card>

<br>

<mat-card>
  <mat-card-header>
    <mat-card-title>Kite/Snowkite Reisen</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Schon seit über 15 Jahren bieten wir für unsere stetig wachsende "Sidewinder" Kite-Community Snowkite & Kitesurfreisen
    an. Alle Reisen sind so ausgelegt das auch Einsteiger ideale Schulungsbedingungen vorfinden. In der Gemeinschaft
    ist man stärker und es macht mehr Spaß. Hier ist der Einstieg über das Snowkiten der Günstigste und auch
    Erfolgsversprechendste. Lasst Euch von diesem facettenreichen Sport der die Elemente miteinander verbindet begeistern.
  </mat-card-content>
  <mat-card-actions>
    <button mat-button color="primary" routerLink="/kitereisen">zu den Kite/Snowkite Reisen</button>
  </mat-card-actions>
</mat-card>

<br>

<div class="video-container">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/SCMgjl-uujs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
